
const baseUrl = `https://www.piano-piano.org/oppdb`;
const imageUrl = "https://www.piano-piano.org/wp-content/uploads/2023/04/piano-piano.jpg";

function getListWorksOfComposer(composer, works) {
  const listWorks = [];
  if(works.length === 0){
    const itemWork = {
      "@type": "ListItem",
      position: 1,
      name: composer?.lastName?? "" + ' ' + composer?.firstName?? "",
      item: `${baseUrl}/?composer=${composer?.firstName}-${composer?.lastName}_${composer?.id}`
    }
    listWorks.push(itemWork);
  }else{
    works?.forEach((item, idx) => {
      const itemWork = {
        "@type": "ListItem",
        position: idx + 1,
        name: item?.title,
        item: `${baseUrl}/?composer=${composer?.firstName}-${composer?.lastName}_${item?.composer_id}`
      }
      listWorks.push(itemWork);
    });
  }
  return listWorks;
}

function getScriptComposer(item) {

  const post = {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    name: item?.lastName?? "" + ' ' + item?.firstName?? "",
    itemListElement: getListWorksOfComposer(item, item?.works)
  }

  return post;
}

function getScriptWork(item) {
  const post = {
    "@context": "https://schema.org",
    "@type": "Article",
    headline: item?.title?? item?.typeChoosen,
    description: item?.content?? item?.typeChoosen ?? item?.instrument ?? item?.mouvement,
    image: imageUrl,
    dateModified: new Date(item?.updated_at).toISOString(),
    datePublished: new Date(item?.created_at).toISOString(),
    author: {
      "@type": "Person",
      name: item?.lastName?? "" + ' ' + item?.firstName?? "",
      url: `${baseUrl}/?composer=${item?.firstName}-${item?.lastName}_${item?.composer_id}`
    },
    publisher:
    {
      "@type": "Person",
      name: item?.publisher?? item?.lastName?? "" + ' ' + item?.firstName?? "",
      url: `${baseUrl}/?composer=${item?.firstName}-${item?.lastName}_${item?.composer_id}`
    },
  }

  return post;
}

function setScriptToHead(arrayData) {
  const script = document.createElement('script');
  script.setAttribute('type', 'application/ld+json');
  script.textContent = JSON.stringify(arrayData);
  document.head.appendChild(script);
}

export function formatWorksScript(data) {
  let arrayData = [];
  data?.forEach((item) => {
    const result = getScriptWork(item);
    arrayData.push(result);
  })
  setScriptToHead(arrayData);
  return;
}

export function formatComposersScript(data) {
  let arrayData = [];
  data?.forEach((item) => {
    const result = getScriptComposer(item);
    arrayData.push(result);
  })
  setScriptToHead(arrayData);
  return;
};
